module.exports = __webpack_public_path__ + "img/backyard-canopy-side.9bb7a31b.webp";